module.exports = __webpack_public_path__ + "img/icon-saveqr.7ea53130.png";